import * as React from 'react';
import { useEffect, useState } from 'react';

import { getImageUrl, useBannersContext } from 'features/banners';

function Image(): JSX.Element {
  const { imageId, layoutId } = useBannersContext();

  const [url, setUrl] = useState('');

  useEffect(() => {
    const nextUrl = getImageUrl({ imageId, layoutId });
    setUrl(nextUrl);
  }, [imageId, layoutId]);

  return (
    <picture className="image" aria-hidden>
      <img src={url} alt="" />
    </picture>
  );
}

export { Image };
